"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const ReadAll = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 20,
  height: 10,
  viewBox: "0 0 20 10"
}, props), _react.default.createElement("path", {
  d: "M14 1a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zm-2 3a1 1 0 100 2h4a1 1 0 100-2h-4zM9 8a1 1 0 100 2h4a1 1 0 100-2H9zM9.216.317a1.019 1.019 0 011.478 0c.408.424.408 1.11 0 1.533L5.019 9.662a1.082 1.082 0 01-.368.26 1.018 1.018 0 01-1.157-.27L.306 6.382a1.113 1.113 0 010-1.532 1.019 1.019 0 011.478 0L4.26 7.383 9.216.317z",
  className: "fill"
}));

var _default = ReadAll;
exports.default = _default;